module.exports = __webpack_public_path__ + "img/Folder.a3eb052b.svg";